<template>
  <div class="container">
    <!-- 加载中 -->
    <div v-if="loading" class="loading-wrap">
      <div class="spinner"></div>
      <p>{{ loadingText }}</p>
    </div>

    <!-- 结果页 -->
    <div v-else class="result-wrap">
      <div class="result-icon">
        <img
          style="width: 108px; height: 100px"
          :src="statu === 1 ? successImg : failImg"
          fit="contain"
        />
      </div>
      <div class="result-tit">{{ resultTitle }}</div>
      <div class="result-desc" v-if="cancelMsg">{{ cancelMsg }}</div>
      <div class="result-desc" v-else-if="statu === 2">收款失败，请重试</div>
    </div>
  </div>
</template>

<script>
import {
  getWechatOpenId,
  wxPayTransfer,
  getJsSdkConfig,
} from "@/api/index"
import { wxAppId } from "@/config"

export default {
  name: "WechatCallback",
  data() {
    return {
      loading: true,
      loadingText: '正在处理收款，请稍候...',
      statu: 1,
      cancelMsg: '',
      successImg: require('@/assets/success.png'),
      failImg: require('@/assets/fail.png'),
    }
  },
  computed: {
    resultTitle() {
      if (this.statu === 1) return '收款成功'
      if (this.cancelMsg) return '收款已取消'
      return '收款失败'
    }
  },
  created() {
    document.title = '收款';
    this.handleCallback()
  },
  methods: {
    async handleCallback() {
      const code = this.$route.query.code
      const orderId = this.$route.query.state || this.$route.query.orderId

      if (!code || !orderId) {
        this.$message.error('回调参数缺失')
        this.statu = 2
        this.loading = false
        return
      }

      try {
        // 1. 用 code 换取 openId
        this.loadingText = '正在获取您的身份信息...'
        const openIdRes = await getWechatOpenId({ code })
        const openId = openIdRes.data.msg || openIdRes.msg
        if (!openId) {
          this.$message.error('获取微信身份信息失败')
          this.statu = 2
          this.loading = false
          return
        }

        // 2. 发起商家转账，获取 mchId + package_info
        this.loadingText = '正在发起转账...'
        const transferRes = await wxPayTransfer({ openId, orderId })
        const { mchId, package_info } = transferRes.data || transferRes
        if (!mchId || !package_info) {
          this.$message.error('发起转账失败，请联系管理员')
          this.statu = 2
          this.loading = false
          return
        }

        // 3. 加载微信 JS-SDK
        this.loadingText = '正在加载安全环境...'
        await this.loadWechatSdk()

        // 4. 获取 JS-SDK 签名
        const signUrl = window.location.href.split('#')[0]
        const sdkRes = await getJsSdkConfig({ url: signUrl })
        const sdkConfig = sdkRes.data || sdkRes
        if (!sdkConfig.appId || !sdkConfig.signature) {
          this.$message.error('获取签名失败，请联系管理员')
          this.statu = 2
          this.loading = false
          return
        }

        // 5. 配置 JS-SDK
        wx.config({
          debug: false,
          appId: sdkConfig.appId,
          timestamp: sdkConfig.timestamp,
          nonceStr: sdkConfig.nonceStr,
          signature: sdkConfig.signature,
          jsApiList: ['requestMerchantTransfer'],
        })

        // 6. 检测并调用 requestMerchantTransfer
        this.loadingText = '即将弹出确认页面...'
        wx.ready(() => {
          wx.checkJsApi({
            jsApiList: ['requestMerchantTransfer'],
            success: (checkRes) => {
              if (checkRes.checkResult.requestMerchantTransfer) {
                // 使用 WeixinJSBridge.invoke 拉起确认页
                WeixinJSBridge.invoke('requestMerchantTransfer', {
                  mchId,
                  appId: wxAppId,
                  package: package_info,
                }, (invokeRes) => {
                  this.loading = false
                  if (invokeRes.err_msg === 'requestMerchantTransfer:ok') {
                    // 用户确认收款成功
                    document.title = '收款成功'
                    this.statu = 1
                  } else if (invokeRes.err_msg === 'requestMerchantTransfer:cancel') {
                    // 用户取消收款
                    document.title = '收款已取消'
                    this.statu = 2
                    this.cancelMsg = '您已取消收款，如需重新收款请返回重新操作'
                  } else {
                    // 拉起确认页失败
                    document.title = '收款失败'
                    this.statu = 2
                  }
                })
              } else {
                this.$message.error('当前微信版本不支持，请更新至最新版本后重试')
                this.statu = 2
                this.loading = false
              }
            },
            fail: () => {
              this.$message.error('环境检测失败')
              this.statu = 2
              this.loading = false
            }
          })
        })

        wx.error((err) => {
          console.error('JS-SDK 配置失败:', err)
          this.$message.error('JS-SDK 配置失败')
          this.statu = 2
          this.loading = false
        })

      } catch (err) {
        console.error('微信收款处理失败:', err)
        this.$message.error('微信收款处理失败，请联系管理员')
        document.title = '收款失败'
        this.statu = 2
        this.loading = false
      }
    },

    loadWechatSdk() {
      return new Promise((resolve) => {
        if (window.wx) { resolve(); return }
        const script = document.createElement('script')
        script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
        script.onload = resolve
        script.onerror = () => {
          this.$message.error('加载微信JS-SDK失败')
          this.statu = 2
          this.loading = false
        }
        document.head.appendChild(script)
      })
    },
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.loading-wrap {
  text-align: center;
  color: #999;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #07C160;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.result-wrap {
  text-align: center;
}

.result-icon {
  margin-bottom: 12px;
}

.result-tit {
  color: #333;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
}

.result-desc {
  color: #999;
  font-size: 14px;
  width: 60%;
  margin: 0 auto;
}
</style>
